import { render, staticRenderFns } from "./CorporateInformation.vue?vue&type=template&id=1751950c&scoped=true&"
import script from "./CorporateInformation.vue?vue&type=script&lang=js&"
export * from "./CorporateInformation.vue?vue&type=script&lang=js&"
import style0 from "./CorporateInformation.vue?vue&type=style&index=0&id=1751950c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1751950c",
  null
  
)

export default component.exports